import index from '@/components/conf/index/index.vue'
import empty from '@/components/common/empty/empty.vue'
export default {
  path: '/activity-manage',
  component: index,
  redirect: '/activity-manage/page',
  name: '活动管理',
  iconCls: '&#xe794;',
  children: [{
    path: 'page',
    component: empty,
    name: '活动页面管理',
    iconCls: '&#xe803;',
    hiddenChildren: true,
    redirect: '/activity-manage/page/list',
    children: [{
      path: 'list',
      component: resolve => require(['@/components/conf/activity-manage/page/index.vue'], resolve),
      name: '活动页面列表'
    }, {
      path: '@attributes',
      component: resolve => require(['@/components/conf/activity-manage/page/attributes/index.vue'], resolve),
      name: '活动页面属性设置'
    }, {
      path: '@edit',
      component: resolve => require(['@/components/conf/activity-manage/page/edit/index.vue'], resolve),
      name: '编辑内容',
      iconCls: '&#xe803;',
      children: []
    }, {
      path: '@source-code',
      component: resolve => require(['@/components/conf/activity-manage/page/source-code/index.vue'], resolve),
      name: '编辑源码',
      iconCls: '&#xe803;',
      children: []
    }]
  }, {
    path: 'signupactive',
    name: '报名活动结果查询',
    iconCls: '&#xe803;',
    component: resolve => require(['@/components/conf/activity-manage/signup/index.vue'], resolve)
  }, {
    path: 'games',
    component: empty,
    name: '互动游戏管理',
    iconCls: '&#xe803;',
    redirect: '/activity-manage/games/list',
    hiddenChildren: true,
    children: [{
      path: 'list',
      component: resolve => require(['@/components/conf/activity-manage/games/index.vue'], resolve),
      name: '互动游戏列表'
    }, {
      path: 'add',
      component: resolve => require(['@/components/conf/activity-manage/games/add.vue'], resolve),
      name: '互动抽奖游戏'
    }]
  }, {
    path: 'wonderful',
    component: empty,
    name: '精彩活动页面管理',
    iconCls: '&#xe803;',
    hiddenChildren: true,
    redirect: '/activity-manage/wonderful/list',
    children: [{
      path: 'list',
      component: resolve => require(['@/components/conf/activity-manage/wonderful/index.vue'], resolve),
      name: '活动页面列表'
    }, {
      path: '@edit',
      component: resolve => require(['@/components/conf/activity-manage/wonderful/edit/index.vue'], resolve),
      name: '编辑内容',
      iconCls: '&#xe803;',
      children: []
    }]
  }, {
    path: 'fridge',
    component: empty,
    name: '冰箱贴活动管理',
    iconCls: '&#xe803;',
    hiddenChildren: true,
    redirect: '/activity-manage/fridge/list',
    children: [{
      path: 'list',
      component: resolve => require(['@/components/conf/activity-manage/fridge/index.vue'], resolve),
      name: '冰箱贴活动管理列表'
    }, {
      path: '@edit',
      component: resolve => require(['@/components/conf/activity-manage/fridge/edit/index.vue'], resolve),
      name: '冰箱贴活动编辑',
      iconCls: '&#xe803;'
    }]
  }, {
    path: 'lottery',
    component: empty,
    name: '抽奖结果查询管理',
    iconCls: '&#xe803;',
    hiddenChildren: true,
    redirect: '/activity-manage/lottery/list',
    children: [{
      path: 'list',
      component: resolve => require(['@/components/conf/activity-manage/lottery/index.vue'], resolve),
      name: '抽奖结果查询列表'
    }, {
      path: '@opportunity',
      component: resolve => require(['@/components/conf/activity-manage/lottery/opportunity/index.vue'], resolve),
      name: '查看抽奖机会列表'
    }, {
      path: '@result',
      component: resolve => require(['@/components/conf/activity-manage/lottery/result/index.vue'], resolve),
      name: '查看抽奖结果列表',
    }]
  }, {
    path: 'electrical-recognition',
    component: empty,
    name: '家电认筹管理',
    iconCls: '&#xe803;',
    hiddenChildren: true,
    redirect: '/activity-manage/electrical-recognition/list',
    children: [{
      path: 'list',
      component: resolve => require(['@/components/conf/activity-manage/electrical-recognition/index.vue'], resolve),
      name: '认筹活动列表'
    }, {
      path: '@edit',
      component: resolve => require(['@/components/conf/activity-manage/electrical-recognition/edit/index.vue'], resolve),
      name: '编辑认筹活动',
      iconCls: '&#xe803;',
      children: []
    }, {
      path: '@result',
      component: resolve => require(['@/components/conf/activity-manage/electrical-recognition/result/index.vue'], resolve),
      name: '查询认筹结果',
      iconCls: '&#xe803;',
      children: []
    }, {
      path: '@promoter',
      component: resolve => require(['@/components/conf/activity-manage/electrical-recognition/promoter/index.vue'], resolve),
      name: '推广员管理',
      iconCls: '&#xe803;',
      children: []
    }]
  }, {
    path: 'we-chat',
    component: empty,
    name: '微信代金券活动管理',
    iconCls: '&#xe803;',
    hiddenChildren: true,
    redirect: '/activity-manage/we-chat/list',
    children: [{
      path: 'list',
      component: resolve => require(['@/components/conf/activity-manage/weChat-cash-coupon/index.vue'], resolve),
      name: '微信代金券活动查询列表'
    }, {
      path: '@edit',
      component: resolve => require(['@/components/conf/activity-manage/weChat-cash-coupon/add.vue'], resolve),
      name: '微信代金券活动编辑'
    }]
  }, {
    path: 'qualify',
    component: empty,
    name: '资格管理',
    iconCls: '&#xe803;',
    hiddenChildren: true,
    redirect: '/activity-manage/qualify/list',
    children: [{
      path: 'list',
      component: resolve => require(['@/components/conf/activity-manage/qualify/index.vue'], resolve),
      name: '资格管理列表'
    }, {
      path: 'add',
      component: resolve => require(['@/components/conf/activity-manage/qualify/add.vue'], resolve),
      name: '资格管理新增'
    }]
  }, {
    path: 'treasure',
    component: empty,
    name: '摇号预约',
    iconCls: '&#xe803;',
    hiddenChildren: true,
    redirect: '/activity-manage/treasure/list',
    children: [{
      path: 'list',
      component: resolve => require(['@/components/conf/activity-manage/treasure/index.vue'], resolve),
      name: '摇号预约列表'
    },{
      path: '@edit',
      component: resolve => require(['@/components/conf/activity-manage/treasure/edit.vue'], resolve),
      name: '摇号预约编辑'
    }]
  }, {
    path: 'vote',
    component: empty,
    name: '投票图片管理',
    iconCls: '&#xe803;',
    hiddenChildren: true,
    redirect: '/activity-manage/vote/list',
    children: [{
      path: 'list',
      component: resolve => require(['@/components/conf/activity-manage/vote/index.vue'], resolve),
      name: '投票图片管理列表'
    }]
  },
  {
    path: 'group-search',
    component: empty,
    name: '茅台团购活动',
    iconCls: '&#xe803;',
    // hiddenChildren: true,
    redirect: '/activity-manage/group-search/list',
    children: [{
      path: 'list',
      component: resolve => require(['@/components/conf/activity-manage/group-search/index.vue'], resolve),
      name: '茅台团购资格查询'
    }, {
      path: 'member-maintenance',
      component: empty,
      name: '企业or高端会员维护',
      hiddenChildren: true,
      redirect: '/activity-manage/group-search/member-maintenance/index',
      children: [{
        path: 'index',
        component: resolve => require(['@/components/conf/activity-manage/group-search/member-maintenance/index.vue'], resolve),
        name: '企业or高端会员维护列表',
      }, {
        path: 'record',
        component: resolve => require(['@/components/conf/activity-manage/group-search/member-maintenance/record.vue'], resolve),
        name: '消费记录维护',
      }, {
        path: 'material',
        component: resolve => require(['@/components/conf/activity-manage/group-search/member-maintenance/material.vue'], resolve),
        name: '资料管理'
      }]
    }]
  }
]}



// WEBPACK FOOTER //
// ./src/router/activity-manage.js